import React from "react";
import messages from "./affiliations-section-messages";
import { FormattedMessage } from "react-intl";
import AffiliationsList from "./affiliations-list";
import { EBSCO_URLS, AFFILIATIONS_SECTION_ID } from "../../../constants";
import "./affiliations-section.scss";

const AffiliationsSection = () => (
  <section className="affiliations-section">
    <h2
      className="affiliations-section__title"
      id={AFFILIATIONS_SECTION_ID}
      tabIndex="-1"
    >
      <FormattedMessage {...messages.title} />
    </h2>
    <p className="affiliations-section__details">
      <FormattedMessage
        {...messages.details}
        values={{
          b: displayBold(),
          a: displayLink()
        }}
      />
    </p>
    <AffiliationsList />
  </section>
);

const displayLink = () => msg => (
  <a
    href={EBSCO_URLS.SUPPORT_SITE}
    target="_blank"
    className="affiliations-section__ebsco-link"
    rel="noopener noreferrer"
  >
    {msg}
  </a>
);

const displayBold = () => msg => <b>{msg}</b>;

export default AffiliationsSection;
